import * as actionTypes from "./UserRegistrationActionTypes";

const clearVerificationDataAction = () => (dispatch: any) => {
  try {
    dispatch({
      type: actionTypes.CLEAR_VERIFICATION_DATA,
      payload: { verification: null },
    });
  } catch (error) {
    return;
  }
};

export { clearVerificationDataAction };
